import React, { Component } from 'react';
import ButtonSelector from './ButtonSelector'
import CurrentButton from '../containers/CurrentButton'
import NavBar from './NavBar'
import ActionList from './ActionList'
import Modal from './Modal'
import ReactTooltip from 'react-tooltip'
import SettingsScreen from '../containers/settingsScreen';
import About from '../containers/About'
import NotCompatible from './NotCompatible'
import NoMIDISupport from './NoMIDISupport'
import { CookiesProvider } from 'react-cookie';
import { withCookies } from 'react-cookie';
import JoyrideWrapper from './JoyrideWrapper';
import { Beforeunload } from 'react-beforeunload';
import { withOneTabEnforcer } from "react-one-tab-enforcer"

class App extends Component {
    render() {
        return (

            <CookiesProvider>
            <Beforeunload onBeforeunload={(event) => event.preventDefault()} />
            <NavBar />
            <ActionList />
            <ButtonSelector />
            <CurrentButton/>
            <ReactTooltip place={"bottom"} effect={"solid"}  delayShow={300} />
            <Modal />
            <SettingsScreen />
            <NotCompatible />
            <NoMIDISupport />
            <About />
            <JoyrideWrapper cookies={this.props.cookies}  />
            </CookiesProvider>
        );
    }
}

export default withOneTabEnforcer({appName: "datalooper-config"})(withCookies(App));
